import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { UserProfileService } from '../services/user-profile.service';

@Directive({
    selector: '[appRestrictPermissions]',
    standalone: true
})
export class RestrictPermissionsDirective implements OnInit {

    public elem: HTMLElement = this._element.nativeElement;

    private _permission: any;
    @Input() set appRestrictPermissions(value: any) {
        this._permission = value;
        this.evaluatePermission();
    }
    get appRestrictPermissions(): any {
        return this._permission;
    }

    @Input() customPermissions: any;

    constructor(private _userProfileService: UserProfileService,
        private _element: ElementRef) { }

    ngOnInit(): void {
        this._userProfileService.currentUser$.subscribe(() => {
            this.evaluatePermission();
        });
    }

    private evaluatePermission() {
        if (this._permission === false) {
            this.elem.classList.add('d-none');
            return;
        }

        if (!this._permission || this._permission === true) {
            return;
        }

        const user = this._userProfileService.currentUser$.getValue();
        const permissionStr = String(this._permission);
        const result = !!user?.permissions?.includes(permissionStr);

        if (result) {
            if (this.elem.classList.contains('fallback-status')) {
                return;
            }
            this.elem.classList.remove('d-none');
        } else {
            if (this.elem.classList.contains('fallback-status') && user?.id !== parseInt(this.elem.id)) {
                this.elem.classList.remove('d-none');
            } else {
                this.elem.classList.add('d-none');
            }
        }

        if (this.customPermissions) {
            Object.entries(this.customPermissions).forEach(permission => {
                if (permission[0] === this._permission && permission[1]) {
                    this.elem.classList.remove('d-none');
                }
            });
        }
    }
}
